import React from 'react';
import FormAddEditPostCategory from '../../../components/blog/categories/FormAddEditPostCategory';
import WrapperSection from '../../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../../components/global/GlobalBreadcrumbs';

const CreatePostCategory = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditPostCategory />
        </WrapperSection>
    );
};

export default CreatePostCategory;
